import { render, staticRenderFns } from "./Dialog-license.vue?vue&type=template&id=50357180&"
import script from "./Dialog-license.vue?vue&type=script&lang=js&"
export * from "./Dialog-license.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports